import Bowser from 'bowser'

const mobileOS = ['iOS','Android','BlackBerry','Windows Phone']

export function allowDragScroll() {
  const browser = Bowser.parse(window.navigator.userAgent)
  const os = browser.os.name
  return browser ? !mobileOS.find(e => os === e) : false
}